// One canonical MIME + helpers shared by collection & binder UI.
export const DRAG_MIME = "application/vnd.spellgather.usercard+json" as const;

export type DragPayload = {
  userCardId: string;
  sourceBinderId?: string;
  sourceSlotId?: string;
};

export function setDragData(e: React.DragEvent, payload: DragPayload) {
  try {
    e.dataTransfer.setData(DRAG_MIME, JSON.stringify(payload));
    // Text fallback helps when dropping onto non-custom targets / OS integrations
    e.dataTransfer.setData("text/plain", payload.userCardId);
    e.dataTransfer.effectAllowed = "move";
  } catch {}
}

export function getDropPayload(e: React.DragEvent): DragPayload | null {
  try {
    const raw = e.dataTransfer.getData(DRAG_MIME);
    if (raw) return JSON.parse(raw);
  } catch {}
  try {
    const txt = e.dataTransfer.getData("text/plain");
    if (txt && !txt.includes("{")) return { userCardId: String(txt) };
  } catch {}
  return null;
}

export function allowDrop(e: React.DragEvent) {
  e.preventDefault();
  try {
    e.dataTransfer.dropEffect = "move";
  } catch {}
}

